import { IKnowledgeBaseArticle } from "../../api/knowledgeBase";

export const cx = (...classNames: Array<string | undefined | false>) =>
  classNames.filter((cn) => !!cn).join(" ");

export const calculateNewPositions = (
  allArticles: IKnowledgeBaseArticle[],
  targetParentId: number | null,
  targetIndex: number,
  movedArticleIds: number[]
): Array<{ id: number; parent_id: number | null; position: number }> => {
  const siblings = allArticles
    .filter(
      (a) => a.parent_id === targetParentId && !movedArticleIds.includes(a.id)
    )
    .sort((a, b) => a.position - b.position);

  const updates: Array<{
    id: number;
    parent_id: number | null;
    position: number;
  }> = [];

  siblings.slice(0, targetIndex).forEach((article, idx) => {
    if (article.position !== idx) {
      updates.push({
        id: article.id,
        parent_id: targetParentId,
        position: idx,
      });
    }
  });

  movedArticleIds.forEach((id, idx) => {
    updates.push({
      id,
      parent_id: targetParentId,
      position: targetIndex + idx,
    });
  });

  siblings.slice(targetIndex).forEach((article, idx) => {
    const newPosition = targetIndex + movedArticleIds.length + idx;
    if (article.position !== newPosition) {
      updates.push({
        id: article.id,
        parent_id: targetParentId,
        position: newPosition,
      });
    }
  });

  return updates;
};

/**
 * Return articles in document order (depth-first, ordered by position within each parent).
 */
export const flattenArticlesToDocumentOrder = (
  articles: IKnowledgeBaseArticle[]
): IKnowledgeBaseArticle[] => {
  if (!articles || articles.length === 0) return [];

  const byParent = new Map<number | null, IKnowledgeBaseArticle[]>();

  articles.forEach((article) => {
    const parentId = article.parent_id;
    const list = byParent.get(parentId) ?? [];
    list.push(article);
    byParent.set(parentId, list);
  });

  const sortChildren = (list: IKnowledgeBaseArticle[]) =>
    [...list].sort((a, b) => a.position - b.position);

  const result: IKnowledgeBaseArticle[] = [];

  const traverse = (parentId: number | null) => {
    const children = byParent.get(parentId);
    if (!children || children.length === 0) return;

    sortChildren(children).forEach((child) => {
      result.push(child);
      traverse(child.id);
    });
  };

  traverse(null);
  return result;
};

